export class DocumentoAyudaMedica
{
    constructor(    public idDocumentoAyudaMedica?: number, 
                    public idAyudaMedica?: number,         
                    public tipoEvento?:string,
                    public idTipoEvento?: number,
                    public rutAfiliado?: string,
                    public beneficiario?: string,
                    public fechaDocumento?: string,
                    public rutPrestador?: string,
                    public nroDocumento?: string,              
                    public montoReembolso?: number,
                    public montoReembolsoSistema?: number,
                    public montoCopago?: number,
                    public montoOtroReembolso?: number,
                    public montoTotalGasto?: number,
                    public proteccionSalud?: string,
                    public proteccionSaludString?: string,  
                    public proteccionSaludArray?: number[],                         
                    public sistemaSalud?: string,
                    public tipoDocumento?: string,
                    public tratamiento?: string,
                    public diagnostico?: string,  
                    public otroSistemaSalud?: string,
                    public otroProteccion?: string

    ) {  }
}   
